import React, { FormEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './Login.module.scss';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthContext } from 'actions/auth-actions';
import { Alert, Box, Button, FormControl, Switch, TextField, Typography } from '@mui/material';
import { useAppSelector } from 'setup/store';
import Images from 'assets/images/common';
import LoadingSpinner from 'components/lib/UI/loadingSpinner/LoadingSpinner';
import { Link } from 'react-router-dom';
import { useAppActions } from 'actions/app-actions';
import { LoginPayload, SnackbarType } from 'common/interfaces';

function ResetPasswordForm() {
  const { resetPassword, setError, resetAuthError } = useAuthContext();
  const { showSnackBar } = useAppActions();
  const error = useAppSelector((state) => state.authReducer.error);
  const loading = useAppSelector((state) => state.authReducer.loading);
  const otpRequested = useAppSelector((state) => state.authReducer.otpRequested);
  const loginPayload = useAppSelector((state) => state.authReducer.loginPayload);
  const [loginData, setLoginData] = useState(loginPayload || ({} as LoginPayload));
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const username = searchParams.get('username');

  useEffect(() => {
    resetAuthError();
  }, []);

  useEffect(() => {
    if (username) {
      setLoginData({ ...loginData, username });
    }
  }, [username]);

  const validate = () => {
    let isValid = true;
    const errs = errors ? { ...errors } : {};
    if (!loginData?.username) {
      isValid = false;
      errs['username'] = 'Username is Required';
    } else if (errs['username']) {
      delete errs['username'];
    }

    if (!loginData?.token) {
      isValid = false;
      errs['token'] = 'Token is Required';
    } else if (errs['token']) {
      delete errs['token'];
    }
    if (!loginData?.password) {
      isValid = false;
      errs['password'] = 'Password is Required';
    } else if (errs['password']) {
      delete errs['password'];
    }
    if (!loginData?.confirmPassword) {
      isValid = false;
      errs['confirmPassword'] = 'Please confirm your password';
    } else if (loginData.password !== loginData.confirmPassword) {
      isValid = false;
      errs['confirmPassword'] = 'Password and Confirm password should be same';
    } else if (errs['confirmPassword']) {
      delete errs['confirmPassword'];
    }

    setErrors(errs);
    return isValid;
  };
  const _handleContinue = async (event: FormEvent) => {
    event.preventDefault();
    const isValid = validate();
    if (isValid) {
      const resp = await resetPassword(loginData);
      if (resp) {
        showSnackBar(SnackbarType.SUCCESS, 'Password resetted successfully');
        navigate('/login');
      }
    }
  };

  const _handleInputChanged = (text: string, key: string) => {
    console.log('Login:username::', text);
    const tempData = { ...loginData, [key]: text };
    setLoginData(tempData);
  };

  useEffect(() => {
    if (loginData) {
      validate();
    }
  }, [loginData]);

  return (
    <Box sx={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>
      <div className={`${classes.container}`}>
        <div className={classes.background}>
          <div className={classes.overlay}></div>
          <img src={Images.LoginBackground4} alt="Login background" />
        </div>
        <div className={classes.loginBox}>
          <div className={classes.logo}>
            {/* <img src={Images.Logo} alt="bonfare logo" /> */}

            <Box display={'flex'} flexDirection={'row'} justifyContent={'center'}>
              <img src={Images.LoginBranding} className={classes.brandingImg} />
              {/* <Typography variant="h5" className={classes.branding}>
                XP Reports
              </Typography> */}
            </Box>
            {/* <Typography variant="h5" className={classes.title}>
              {t('login.title')}
            </Typography> */}
          </div>

          <Box
            component="form"
            sx={
              {
                // '& .MuiTextField-root': { m: 1, width: '25ch' },
              }
            }
            className={classes.formContainer}
            onSubmit={_handleContinue}
          >
            <div>
              <FormControl fullWidth className={classes.rowItem}>
                <TextField
                  fullWidth
                  error={errors && errors['username']?.length > 0 ? true : false}
                  id="outlined-error-helper-text"
                  label="Username"
                  value={loginData.username}
                  disabled
                  placeholder={'Enter username'}
                  helperText={errors['username'] || ''}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setError(null);
                    setLoginData({ ...loginData, username: event.target.value });
                  }}
                />
              </FormControl>
              <FormControl fullWidth className={classes.rowItem}>
                <TextField
                  fullWidth
                  error={errors && errors['token']?.length > 0 ? true : false}
                  id="outlined-error-helper-text"
                  label="Verification Code"
                  value={loginData.token}
                  placeholder={'Enter verification code.'}
                  helperText={errors['token'] || ''}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setError(null);
                    setLoginData({ ...loginData, token: event.target.value });
                  }}
                />
              </FormControl>
              <FormControl fullWidth className={classes.rowItem}>
                <TextField
                  fullWidth
                  type="password"
                  error={errors && errors['password']?.length > 0 ? true : false}
                  id="outlined-error-helper-text"
                  label="Password"
                  value={loginData.password}
                  placeholder={'Enter password'}
                  helperText={errors['password'] || ''}
                  className="rowItem"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setError(null);
                    setLoginData({ ...loginData, password: event.target.value });
                  }}
                />
              </FormControl>
              <FormControl fullWidth className={classes.rowItem}>
                <TextField
                  fullWidth
                  type="password"
                  error={errors && errors['confirmPassword']?.length > 0 ? true : false}
                  id="outlined-error-helper-text"
                  label="Confirm Password"
                  value={loginData.confirmPassword}
                  placeholder={'Confirm password'}
                  helperText={errors['confirmPassword'] || ''}
                  className="rowItem"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setError(null);
                    setLoginData({ ...loginData, confirmPassword: event.target.value });
                  }}
                />
              </FormControl>
              {error ? (
                <FormControl fullWidth>
                  <Alert severity="error" style={{ marginBottom: '10px' }}>
                    {error.msg}
                  </Alert>
                </FormControl>
              ) : null}

              <FormControl fullWidth>
                <Button
                  variant="contained"
                  onClick={_handleContinue}
                  fullWidth
                  size="large"
                  className={classes.btn}
                  type="submit"
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {loading ? <LoadingSpinner size="small" style={{ marginRight: '10px' }} /> : null} Submit
                  </Box>
                </Button>
              </FormControl>
              <div style={{ marginTop: '15px' }}>
                <Link to={'/login'} onClick={() => setError(null)}>
                  Back
                </Link>
              </div>
            </div>
          </Box>
        </div>
      </div>
    </Box>
  );
}

export default ResetPasswordForm;
